/* eslint-disable react/jsx-props-no-spreading */
import { useField } from "@unform/core";
import { useEffect, useRef } from "react";
import "./styles.scss";

type SelectProps = {
  name: string;
  label: string;
  onChange?: (event: any) => void;
  value?: string | number;
  style?: any;
};

const Select: React.FC<SelectProps> = ({
  name,
  label,
  value,
  style,
  onChange,
  children,
  ...rest
}) => {
  const selectRef = useRef(null);

  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: "value",
    });
  }, [fieldName, registerField]);

  return (
    <div style={style} className="selectContainer">
      <label>{label}</label>
      <div className="select_box">
        <select
          value={value}
          onChange={onChange}
          ref={selectRef}
          name={name}
          defaultValue={0}
          {...rest}
        >
          {children}
        </select>
      </div>
      {error && <span className="error">{error}</span>}
    </div>
  );
};

export default Select;
